$(".matrix--heading")
  .mouseenter(function () {
    if(getViewportWidth() >= 961) {
      $(this).find(".anchor-marker").css("display", "inline-block");
    }
  })
  .mouseleave(function () {
    $(this).find(".anchor-marker").css("display", "none");
  });
